import { Component, OnInit , Input, OnChanges , SimpleChanges, AfterViewInit} from '@angular/core';
import { FormsService } from '../../../shared/services/forms.service';
import {MatDialog, MatSnackBar} from '@angular/material';
import { Router } from '@angular/router';
import {environment} from '../../../../../environments/environment';
import {CognitoUtil} from '../../../shared/services/cognito.service';
import { LocalUserService } from '../../../shared/services/localUser';
import { TownDialogComponent } from 'app/main/shared/dialog/town-dialog/town-dialog.component';

@Component({
  selector: 'newPetition',
  templateUrl: './new-petition.component.html',
  styleUrls: ['./new-petition.component.scss'],
  providers: [
    FormsService,
    LocalUserService
  ]
})
export class NewPetitionComponent implements OnInit {

  id: string;
  role: string;
  token: string;
  org: string;

  formLoading = true;
  error: string;
  forms: any = null;
  displayedColumns: string[] = ['id', 'name', 'description','fee','action'];
  

  constructor(
    private formsService: FormsService,
    private router: Router,
    private cognito: CognitoUtil,
    public snackBar: MatSnackBar,
    private localUser: LocalUserService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.id = this.localUser.getUserId();
    this.role = this.localUser.getRole();
    this.org = this.localUser.getOrganizationId();
    this.getForms();
  }

  getForms(){

    this.formLoading = true;

    this.formsService.getForms(this.org, this.role)
      .subscribe( result => {
        this.forms = result;
        this.formLoading = false;
        });
  }

  makeNewCase(id){
    const confirmDialog = this.dialog.open(TownDialogComponent,{
      panelClass:"confirmDetails",
      data: id
    });
  }

  centsToDollars(cents){
    return '$' + (cents / 100);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/new-petition/new-petition.component.ts